<template>
	<div class="wrapper">
		<div class="search">
			<input type="text" class="txt" placeholder="搜索" @input="specifiName($event)">
		</div>
		<div class="body">
			<el-amap vid="amap" style="height:0" :plugin="plugin" class="amap-demo" :center="center"></el-amap>
			<scroller height="100%" :on-refresh="refresh" :on-infinite="infinite" ref="scrollerBottom">
				<main class="scrollerContent">
					<!-- <div v-for="item in list" class="list">{{item}}</div> -->
					<div class="list" v-for="item in list" :key="item.id">
						<img src="../assets/img8-logo.png" alt="中石油">
						<div class="rt">
							<h1>{{item.oilStation.name}}</h1>
							<p>{{item.oilStation.address}}</p>
							<div class="eval">
								<div class="star">
									<span class="full" :style="{width:15*item.oilStation.starLevel+'px'}"></span>
								</div>
								<div class="dist">
									<span>{{item.distance}}km</span>
								</div>
							</div>
						</div>
					</div>
				</main>
			</scroller>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			let self = this;
			return {
				isBottom: false,
				loadingTips: '',
				page: 1,
				list: [],
				name: '',
				center: [121.59996, 31.197646],
				lng: 0,
				lat: 0,
				loaded: false,
				plugin: [{
					pName: 'Geolocation',
					events: {
						init(o) {
							// o 是高德地图定位插件实例
							o.getCurrentPosition((status, result) => {
								// console.log(result)
								// console.log(result.addressComponent.township)
								if (result && result.position) {
									self.lng = result.position.lng;
									self.lat = result.position.lat;
									self.center = [self.lng, self.lat];
									self.getDataList('', result.position.lng, result.position.lat, 1);
									self.loaded = true;
									self.$nextTick();
								}
							});
						}
					}
				}]
			}
		},
		created() {
			this.initDataList()
		},
		methods: {
			initDataList() {
				let _this = this
				setTimeout(() => {
					if (!_this.list || _this.list.length == 0) {
						_this.lng = 121.59996;
						_this.lat = 31.197646;
						_this.center = [_this.lng, _this.lat];
						_this.getDataList('', _this.lng, _this.lat, 1);
						_this.loaded = true;
						_this.$nextTick();
					}
				},5000)
			},
			specifiName(e) {
				this.name = e.target.value;
				this.getDataList(this.name, this.lng, this.lat, 1);
			},
			getDataList(name, lng, lat, pageNum, done) {
				const obj = {
					name: name,
					lng: lng,
					lat: lat,
					pageNum: pageNum,
					pageSize: 6
				};
				this.$http.POST('oilStation/listOilStation', obj).then(res => {
					if (res.code === 0) {
						if (typeof(done) == "function") {
							done();
						}
						if (res.data.list.length !== 0) {
							this.isBottom = false;
							if (pageNum == 1) {
								this.list = res.data.list;
							} else {
								this.list = this.list.concat(res.data.list);
							}

						} else {
							this.$refs.scrollerBottom.finishInfinite(false);
							this.list = [];
							this.isBottom = true;
						}
					}
				});
			},
			refresh(done) { //下拉刷新
				this.page = 1;
				this.list = [];
				// if (this.lng != 0 && this.lat != 0) {
				this.getDataList(this.name, this.lng, this.lat, 1,done);
				// }
			},
			infinite(done) { //上拉加载
				if (this.isBottom) { //当没有更多数据的时候结束加载
					this.loadingTips = "无更多数据"
					setTimeout(() => {
						done && done(true);
					}, 1000);
				} else { //有更多数据时进行数据分页显示
					setTimeout(() => {
						this.page++;
						// this.getDataList(this.page);
						if (this.page > 1) {
							this.getDataList('', this.lng, this.lat, this.page, done);
						}
						this.$nextTick(() => {
							// this.$refs.scrollerBottom.reset()
						})
					}, 500)
				}
			},
		},

		mounted() {

		}
	}
</script>
<style lang="scss" scoped>
	.wrapper {
		height: 100%;
		position: relative;

		.search {
			padding: 8px 9px;
			background: #fff;

			.txt {
				height: 30px;
				line-height: 30px;
				width: 323px;
				background: url('../assets/search.png') 14px center #F3F3F3 no-repeat;
				background-size: 14px 14px;
				border: none;
				border-radius: 1px;
				color: #9C9C9D;
				font-size: 15px;
				padding-left: 34px;
			}
		}

		.body {
			margin-top: 10px;
			background: #fff;
			width: 100%;
			height: 88%; //有header的时候可能会出现滚动条，所以最好高度是除去header的高度
			top: 50px; //一般页面有header的时候需要留出header的高度
			bottom: 20px;
			position: absolute;

			main {
				height: 100%;

				.list {
					border-bottom: 1px solid #F3F3F3;
					display: flex;
					padding: 12px 15px;
					align-items: center;

					img {
						width: 65px;
						height: 65px;
					}

					.rt {
						flex: 1;
						padding-left: 15px;

						h1 {
							color: #333333;
							font-weight: bold;
							font-size: 15px;
						}

						p {
							color: #666666;
							font-size: 12px;
							padding-bottom: 16px;
						}

						.eval {
							display: flex;
							align-items: center;

							.star {
								// flex: 1;
								width: 75px;
								height: 15px;
								background: url('../assets/star1.png') repeat-x;
								background-size: 15px 15px;
								display: flex;

								span {
									width: 15px;
									background: url('../assets/star2.png') repeat-x;
									background-size: 15px 15px;
								}
							}

							.dist {
								flex: 1;
								display: flex;

								span {
									height: 21px;
									line-height: 21px;
									flex: 1;
									text-align: right;
									font-size: 15px;
									color: #666666;
									background: url('../assets/dist1.png') right center no-repeat;
									background-size: 12px 14px;
									padding-right: 17px;
								}
							}
						}
					}
				}
			}
		}
	}
</style>
